import React, { useRef } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Home } from './home';
import { Row, Col } from 'reactstrap';
import { ErrorBoundary } from './errors/error-boundary'
import { useTranslate } from "react-translate";

export function Layout(props) {
    const footer = useRef(null);
    const t = useTranslate("Common");
    return (
        <>
            <div className="rootLayout">
                <div ref={footer} className='logoContainer'>
                    <a href="https://www.compositeurdigital.com/wp/fr/accueil" target="_blank" rel="noopener noreferrer">
                        <img src="assets/logoCDUX.png" className="logoFull" alt="Compositeur Digital UX" />
                        <img src="assets/logoCDUX_small.png" className="logoSmall" alt="Compositeur Digital UX" />
                    </a>
                </div>
                <ErrorBoundary message={t("error")}>
                    <div className="globalContainer">
                        <Row className="align-items-center" style={{ height: '100%', textAlign: 'center' }} >
                            <Col>
                            <Routes>                               
                                  <Route path='/:sessionId?' element={<Home footerRef={footer} />} />                          
                            </Routes>
                            </Col>
                        </Row>
                    </div>
                </ErrorBoundary>
            </div>
        </>
    );
}
